<template>
    <div class="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div class="relative w-full h-full flex flex-col gap-4 p-4">
            <h1 class="text-lg">{{ $t("settings.auto.manejo_de_roles_y_permisos") }}</h1>
            <section class="rounded-lg border border-ewhite-200 bg-white p-4">
                <h2 class="text-base font-semibold text-eblack-900">{{ $t("settings.auto.administrador_vs_empleado") }}</h2>
                <div class="mt-3 overflow-x-auto">
                    <table class="min-w-full text-left text-sm">
                        <thead class="text-eblack-600">
                            <tr>
                                <th class="border-b p-2">{{ $t("settings.auto.area") }}</th>
                                <th class="border-b p-2">{{ $t("settings.auto.administrador") }}</th>
                                <th class="border-b p-2">{{ $t("settings.auto.empleado") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in roleComparison" :key="row.area">
                                <td class="border-b p-2 font-medium">{{ row.area }}</td>
                                <td class="border-b p-2">{{ row.admin }}</td>
                                <td class="border-b p-2">{{ row.staff }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            
            <div
                v-if="canManageRoles"
                class="w-full flex  justify-between gap-y-5"
            >
                <button 
                type="button"
                class="bg-egreen-500 w-auto text-white py-1 px-4 rounded-lg text-md inline-flex justify-center items-center gap-2"
                @click="showModal = true">
                    <span>{{ $t("settings.auto.agregar") }}</span>
                </button>
            </div>

            <div v-if="canManageRoles" class="w-full grid grid-cols-3 gap-4">
                <div 
                class="w-full h-auto flex flex-col rounded-lg border bg-white shadow-md p-2 px-3 gap-3"
                v-for="role in roles"
                :key="role.id">
                    <div class="flex justify-between">
                        <h1 class="text-lg tracking-wide">{{ role.name }}</h1>
                        <button 
                            class="px-1 bg-eblue-500 text-sm text-white rounded-md flex items-center"
                            type="button"
                            @click="setRole(role)">
                            <IconEdit class="w-5 h-5" />
                        </button>
                    </div>

                    <p class="text-md">{{ $t("settings.auto.permisos_aplicados") }}</p>

                    <div class="flex items-center flex-wrap gap-2 ">
                        <span class="px-2 py-0.5 rounded-md text-eblack-950 bg-white border border-eblack-500 flex items-center gap-1 text-xs"
                        v-for="permission in role.permissions"
                        :key="permission.id">
                            {{ permission.name }}
                        </span>
                    </div>
                </div>
            </div>

            <ActionModal 
            v-if="canManageRoles"
            :permissions="permissions" 
            :role="role"
            @close="handleCloseModal" 
            @create="handleAddRole"
            @update="handleEditRole"
            v-show="showModal" />
        </div>
    </div>
</template>

<script>
import { i18n } from "@/i18n";
import rolesRequest from '@/services/admin/role-service.js';
import permissionsRequest from '@/services/admin/permissions-service.js';
import ActionModal from './components/ActionModal.vue';
import { IconEdit } from '@tabler/icons-vue';
import { useAbility } from '@/domains/auth';
import { ROLE_ACCESS_COMPARISON } from '@/domains/organization/models/role-access-table';

import { useToast } from "vue-toastification";
export default {
    name:'RoleIndex',
    setup(){
        const { can } = useAbility();
        return { can };
    },
    data(){
        return {
            roles:[],
            roles_list:[],
            permissions:[],
            showModal:false,
            role:null,
            toast:useToast(),
            roleComparison:ROLE_ACCESS_COMPARISON
        }
    },
    components:{
        ActionModal,
        IconEdit
    },
    computed:{
        canManageRoles(){
            return this.can("manage", "Role") || this.can("manage", "all");
        }
    },
    methods:{
        handleCloseModal(){
            this.showModal = false;
            this.role = null
        },
        initData(){
            if(!this.canManageRoles){
                return;
            }
            this.getRoles();
            this.getPermissions();
        },
        getRoles(){
            rolesRequest.getAll()
            .then(response=>{
                if(response.status == 200){
                    let { data } = response;
                    this.roles = data;
                }
            })
            .catch(error=>{
                console.log(error);
            })
        },
        getPermissions(){
            permissionsRequest.getAll()
            .then(response=>{
                if(response.status == 200){
                    let { data } = response;
                    this.permissions = data;
                }
            })
            .catch(error=>{
                console.log(error);
            })
        },
        setRole(role){
            if(!this.canManageRoles){
                return;
            }
            this.role = role;
            this.showModal = true;
        },
        handleAddRole(form){
            if(!this.canManageRoles){
                return;
            }
            rolesRequest.save(form)
            .then(response=>{
                if(response.status == 201){
                    this.getRoles();
                    this.showModal = false;
                    this.toast.success(i18n.global.t("settings.auto.role_guardado"), {
                        timeout: 3000,
                        position: "top-right"
                    });
                }
            })
            .catch(error=>{
                console.log(error);
                this.toast.error(i18n.global.t("settings.auto.hubo_un_problema_al_guardar"), {
                    timeout: 3000,
                    position: "top-right"
                });
            })
        },
        handleEditRole(form){
            if(!this.canManageRoles){
                return;
            }
            let {id,...data} = form;

            rolesRequest.update(id,data)
            .then(response=>{
                if(response.status == 200){
                    this.getRoles();
                    this.showModal = false;

                    this.toast.success(i18n.global.t("settings.auto.role_actualizado"), {
                        timeout: 3000,
                        position: "top-right"
                    });
                }
            })
            .catch(error=>{
                console.log(error);

                this.toast.error(i18n.global.t("settings.auto.hubo_un_problema_al_actualizar"), {
                    timeout: 3000,
                    position: "top-right"
                });
            })
        }
    },
    mounted(){
        this.initData();
    }
}
</script>

<style lang="scss" scoped>

</style>
